import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isScrolled, setIsScrolled] = useState(false)
  const [activeSection, setActiveSection] = useState('home')
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100)
      
      // Only update active navigation link if we're on the home page
      if (location.pathname === '/') {
        const sections = document.querySelectorAll('section[id]')
        const scrollPosition = window.scrollY + 100
        
        sections.forEach(section => {
          const sectionTop = section.offsetTop
          const sectionHeight = section.clientHeight
          if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
            setActiveSection(section.getAttribute('id'))
          }
        })
      }
    }

    // Set active section based on current location
    if (location.pathname === '/about') {
      setActiveSection('about')
    } else if (location.pathname === '/') {
      setActiveSection('home')
    }

    const handleClickOutside = (e) => {
      const navbar = document.querySelector('.navbar')
      const hamburger = document.querySelector('.hamburger')
      if (isMenuOpen && navbar && !navbar.contains(e.target) && !hamburger?.contains(e.target)) {
        closeMenu()
      }
    }

    window.addEventListener('scroll', handleScroll)
    document.addEventListener('click', handleClickOutside)
    
    return () => {
      window.removeEventListener('scroll', handleScroll)
      document.removeEventListener('click', handleClickOutside)
    }
  }, [isMenuOpen, location.pathname])

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
    document.body.style.overflow = !isMenuOpen ? 'hidden' : ''
    document.body.classList.toggle('menu-open', !isMenuOpen)
  }

  const closeMenu = () => {
    setIsMenuOpen(false)
    document.body.style.overflow = ''
    document.body.classList.remove('menu-open')
  }

  const scrollToSection = (sectionId) => {
    const target = document.getElementById(sectionId)
    if (target) {
      const navbarHeight = document.querySelector('.navbar').offsetHeight
      const targetPosition = target.offsetTop - navbarHeight - 20
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      })
      closeMenu()
    }
  }

  const handleNavigation = (sectionId) => {
    if (location.pathname === '/') {
      // If we're on home page, just scroll to section
      scrollToSection(sectionId)
    } else {
      // If we're on another page, navigate to home and then scroll
      navigate('/')
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        scrollToSection(sectionId)
      }, 300)
    }
  }

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`} role="navigation" aria-label="منوی اصلی">
      <div className="nav-container">
        <div className="nav-logo">
          <h2 onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>سمیه ارباب مجنی</h2>
        </div>
        <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <li className="nav-item">
            <a 
              href="#home" 
              className={`nav-link ${activeSection === 'home' ? 'active' : ''}`}
              onClick={(e) => {
                e.preventDefault()
                handleNavigation('home')
              }}
            >
              صفحه اصلی
            </a>
          </li>
          <li className="nav-item">
            <a 
              href="#about" 
              className={`nav-link ${activeSection === 'about' ? 'active' : ''}`}
              onClick={(e) => {
                e.preventDefault()
                handleNavigation('about')
              }}
            >
              درباره من
            </a>
          </li>
          <li className="nav-item">
            <a 
              href="#services" 
              className={`nav-link ${activeSection === 'services' ? 'active' : ''}`}
              onClick={(e) => {
                e.preventDefault()
                handleNavigation('services')
              }}
            >
              خدمات آموزشی
            </a>
          </li>
          <li className="nav-item">
            <a 
              href="#courses" 
              className={`nav-link ${activeSection === 'courses' ? 'active' : ''}`}
              onClick={(e) => {
                e.preventDefault()
                handleNavigation('courses')
              }}
            >
              دروس من
            </a>
          </li>
          <li className="nav-item">
            <a 
              href="#method" 
              className={`nav-link ${activeSection === 'method' ? 'active' : ''}`}
              onClick={(e) => {
                e.preventDefault()
                handleNavigation('method')
              }}
            >
              روش تدریس
            </a>
          </li>
          <li className="nav-item">
            <a 
              href="#contact" 
              className={`nav-link ${activeSection === 'contact' ? 'active' : ''}`}
              onClick={(e) => {
                e.preventDefault()
                handleNavigation('contact')
              }}
            >
              تماس
            </a>
          </li>
        </ul>
        <button 
          className={`hamburger ${isMenuOpen ? 'active' : ''}`} 
          aria-label="منوی اصلی" 
          aria-expanded={isMenuOpen}
          onClick={toggleMenu}
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>
      </div>
    </nav>
  )
}

export default Navbar 